import { SubscriptionCreate } from '../../apis/asaas/asaasapi';

export const SubscriptionService = {
  create: async (data: AsaasSubscription) => {
    return await SubscriptionCreate(data);
  },
};
